package com.arena_web.data.repository

import com.arena_web.data.api.SubscriptionApi
import com.arena_web.data.dto.*
import com.arena_web.domain.repositories.SubscriptionRepository

class SubscriptionRepositoryImpl(private val subscriptionApi: SubscriptionApi) : SubscriptionRepository {

    override suspend fun getSubscription(): Result<SubscriptionDto> =
        apiCall { subscriptionApi.getSubscription() }

    override suspend fun checkout(source: String?, trial: Boolean): Result<SubscriptionCheckoutDto> =
        apiCall { subscriptionApi.checkout(source, trial) }

    override suspend fun confirmCheckout(request: SubscriptionConfirmRequest): Result<SubscriptionDto> =
        apiCall { subscriptionApi.confirmCheckout(request) }

    override suspend fun cancel(): Result<SubscriptionDto> =
        apiCall { subscriptionApi.cancel() }
}
